import { findNearestCity } from './philippineCities.js';

// Philippine volcano data
export const philippineVolcanoes = [
  {
    id: 'mayon',
    name: 'Mayon Volcano',
    lat: 13.257,
    lng: 123.685,
    elevation: 2463,
    type: 'stratovolcano',
    status: 'active',
    lastEruption: '2018',
    alertLevel: 1,
    province: 'Albay',
    region: 'Bicol Region',
    description: 'Most active volcano in the Philippines, known for its perfect cone shape',
  },
  {
    id: 'taal',
    name: 'Taal Volcano',
    lat: 14.0009,
    lng: 120.983,
    elevation: 311,
    type: 'complex',
    status: 'active',
    lastEruption: '2022',
    alertLevel: 1,
    province: 'Batangas',
    region: 'CALABARZON',
    description: 'Complex volcano located on Taal Lake, second most active volcano',
  },
  {
    id: 'pinatubo',
    name: 'Mount Pinatubo',
    lat: 15.13,
    lng: 120.35,
    elevation: 1486,
    type: 'stratovolcano',
    status: 'active',
    lastEruption: '1993',
    alertLevel: 0,
    province: 'Zambales',
    region: 'Central Luzon',
    description: 'Famous for its 1991 eruption, one of the largest of the 20th century',
  },
  {
    id: 'kanlaon',
    name: 'Kanlaon Volcano',
    lat: 10.412,
    lng: 123.132,
    elevation: 2435,
    type: 'stratovolcano',
    status: 'active',
    lastEruption: '2024',
    alertLevel: 2,
    province: 'Negros Occidental',
    region: 'Western Visayas',
    description: 'Highest peak in the Visayas, frequently active',
  },
  {
    id: 'bulusan',
    name: 'Bulusan Volcano',
    lat: 12.769,
    lng: 124.054,
    elevation: 1565,
    type: 'stratovolcano',
    status: 'active',
    lastEruption: '2023',
    alertLevel: 1,
    province: 'Sorsogon',
    region: 'Bicol Region',
    description: 'Active volcano in southern Luzon',
  },
  {
    id: 'hibok-hibok',
    name: 'Mount Hibok-Hibok',
    lat: 9.2,
    lng: 124.67,
    elevation: 1332,
    type: 'stratovolcano',
    status: 'active',
    lastEruption: '1952',
    alertLevel: 0,
    province: 'Camiguin',
    region: 'Northern Mindanao',
    description: 'Active volcano on Camiguin Island',
  },
  {
    id: 'ragang',
    name: 'Mount Ragang',
    lat: 7.675,
    lng: 124.142,
    elevation: 2815,
    type: 'stratovolcano',
    status: 'active',
    lastEruption: '1916',
    alertLevel: 0,
    province: 'Lanao del Sur',
    region: 'BARMM',
    description: 'Highest point in Lanao del Sur',
  },
  {
    id: 'smith',
    name: 'Mount Smith',
    lat: 5.533,
    lng: 125.317,
    elevation: 688,
    type: 'stratovolcano',
    status: 'active',
    lastEruption: '1897',
    alertLevel: 0,
    province: 'Davao Occidental',
    region: 'Davao Region',
    description: 'Active volcano in Mindanao',
  },
  {
    id: 'parker',
    name: 'Mount Parker',
    lat: 6.117,
    lng: 124.883,
    elevation: 1824,
    type: 'stratovolcano',
    status: 'active',
    lastEruption: '1641',
    alertLevel: 0,
    province: 'South Cotabato',
    region: 'SOCCSKSARGEN',
    description: 'Stratovolcano with a crater lake',
  },
  {
    id: 'banahaw',
    name: 'Mount Banahaw',
    lat: 14.017,
    lng: 121.483,
    elevation: 2158,
    type: 'stratovolcano',
    status: 'potentially-active',
    lastEruption: '1909',
    alertLevel: 0,
    province: 'Quezon',
    region: 'CALABARZON',
    description: 'Sacred mountain and potentially active volcano',
  },
];

// Alert level definitions
export const volcanoAlertLevels = {
  0: { name: 'Normal', color: '#10b981', description: 'No volcanic activity', bgColor: 'bg-green-100', textColor: 'text-green-800' },
  1: { name: 'Abnormal', color: '#f59e0b', description: 'Low-level unrest', bgColor: 'bg-amber-100', textColor: 'text-amber-800' },
  2: { name: 'Increasing Unrest', color: '#fb923c', description: 'Magmatic intrusion', bgColor: 'bg-orange-100', textColor: 'text-orange-800' },
  3: { name: 'Increased Tendency', color: '#ef4444', description: 'Relatively high unrest', bgColor: 'bg-red-100', textColor: 'text-red-800' },
  4: { name: 'Intense Unrest', color: '#dc2626', description: 'Hazardous eruption imminent', bgColor: 'bg-red-200', textColor: 'text-red-900' },
  5: { name: 'Hazardous Eruption', color: '#991b1b', description: 'Hazardous eruption ongoing', bgColor: 'bg-red-300', textColor: 'text-red-950' },
};

// Helper function to get volcano marker style
export const getVolcanoMarkerStyle = (volcano) => {
  const alertConfig = volcanoAlertLevels[volcano.alertLevel] || volcanoAlertLevels[0];
  const size = volcano.alertLevel >= 3 ? 20 : volcano.alertLevel >= 1 ? 15 : 12;
  return {
    radius: size,
    fillColor: alertConfig.color,
    color: '#ffffff',
    weight: 2,
    opacity: 0.8,
    fillOpacity: 0.7,
  };
};

// Helper function to create popup content for volcanoes
export const createVolcanoPopupContent = (volcano) => {
  const alertConfig = volcanoAlertLevels[volcano.alertLevel] || volcanoAlertLevels[0];
  return `
    <div class="p-3 min-w-[250px]">
      <div class="font-semibold text-lg mb-2 flex items-center space-x-2">
        <span>🌋</span>
        <span style="color: ${alertConfig.color}">${volcano.name}</span>
      </div>
      <div class="space-y-2 text-sm">
        <div><strong>Type:</strong> ${volcano.type.charAt(0).toUpperCase() + volcano.type.slice(1)}</div>
        <div><strong>Elevation:</strong> ${volcano.elevation.toLocaleString()} m</div>
        <div><strong>Status:</strong> ${volcano.status.charAt(0).toUpperCase() + volcano.status.slice(1)}</div>
        <div><strong>Province:</strong> ${volcano.province}</div>
        <div><strong>Region:</strong> ${volcano.region}</div>
        <div><strong>Last Eruption:</strong> ${volcano.lastEruption || 'No recorded eruption'}</div>
        <div class="mt-2">
          <div class="font-medium mb-1">Alert Level:</div>
          <div class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${alertConfig.bgColor} ${alertConfig.textColor}">
            Level ${volcano.alertLevel}: ${alertConfig.name}
          </div>
        </div>
        <div class="mt-2 text-xs text-gray-600 italic">
          ${volcano.description}
        </div>
      </div>
    </div>
  `;
};

// Helper function to generate volcanic activity data
export const generateVolcanicActivity = () => {
  const activities = [];
  const now = new Date();

  // Generate volcanic activity for active volcanoes with alert levels > 0
  philippineVolcanoes.forEach(volcano => {
    if (volcano.alertLevel > 0 && Math.random() > 0.3) {
      const activityTypes = {
        1: ['steaming', 'ground deformation', 'increased seismicity'],
        2: ['phreatic eruption', 'magma intrusion', 'rockfall events'],
        3: ['lava dome growth', 'ash emission', 'pyroclastic flows'],
        4: ['magma eruption', 'lava fountaining', 'pyroclastic density currents'],
        5: ['explosive eruption', 'lava flows', 'pyroclastic flows'],
      };
      const possibleActivities = activityTypes[volcano.alertLevel] || activityTypes[1];
      const activity = possibleActivities[Math.floor(Math.random() * possibleActivities.length)];

      activities.push({
        id: `volcanic:${volcano.id}-${Date.now()}`,
        source: 'phivolcs',
        type: 'volcanic',
        event_type: activity.replace(' ', '_'),
        time_utc: new Date(now.getTime() - Math.random() * 48 * 60 * 60 * 1000).toISOString(),
        magnitude: volcano.alertLevel,
        lat: volcano.lat + (Math.random() - 0.5) * 0.1,
        lng: volcano.lng + (Math.random() - 0.5) * 0.1,
        place_text: `${activity.charAt(0).toUpperCase() + activity.slice(1)} - ${volcano.name}`,
        nearest_city: findNearestCity(volcano.lat, volcano.lng),
        province: volcano.province,
        alert: volcano.alertLevel >= 3 ? 'Warning' : volcano.alertLevel >= 1 ? 'Watch' : 'Advisory',
        tsunami: null,
        volcano_info: {
          volcano_id: volcano.id,
          volcano_name: volcano.name,
          alert_level: volcano.alertLevel,
          elevation: volcano.elevation,
          activity_type: activity,
        },
      });
    }
  });

  return activities;
};